import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const CopyIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="CopyIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/copy">
            <path
                id="Vector"
                d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
